module.exports = __webpack_public_path__ + "lato-regular-webfont.ea9ad28ddfa9cf6657ef.eot";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-regular-webfont.eot
// module id = ../../../../../resources/fonts/lato-regular-webfont.eot
// module chunks = styles